import CasesHighlightItem from "./cases-highlight-item";
import "./cases-highlights-block.sass";

type Props = {
  stats?: {
    id: string;
    color: { hex: string };
    description: string;
    number: string;
  }[];
  className?: string;
};

const CasesHighlightsBlock = ({ stats, className }: Props) => {
  let highlightItemWidth = "100%";

  switch (stats && stats.length) {
    case 2:
      highlightItemWidth = "calc((100% - 8px) / 2)";
      break;
    case 3:
      highlightItemWidth = "calc((100% - 16px) / 3)";
      break;
    case 4:
      highlightItemWidth = "calc((100% - 24px) / 4)";
      break;
    default:
      highlightItemWidth = "100%";
      break;
  }
  return (
    <div className={`cases-highlights-block ${className}`}>
      {stats &&
        stats.map((stat, index) => (
          <CasesHighlightItem
            key={stat.id}
            color={stat.color && stat.color.hex ? stat.color.hex : "#115EF3"}
            text={stat.description}
            value={stat.number}
            width={highlightItemWidth}
            index={index}
          />
        ))}
    </div>
  );
};

export default CasesHighlightsBlock;
